import {isNullOrUndefined} from "../../../services/Validator";

export default function ThemesItemDescriptionText({themeDescription}) {
    // Used in ThemesItem to display Theme short description
    // text

    // BUILD
    if (isNullOrUndefined(themeDescription))
        return null
    return (
        <div>
            <span className={"text-[16px] text-greyLight11 font-medium"}>
                {themeDescription}
            </span>
        </div>
    );
}